<!-- Modal Matrícula Activa -->
<div class="modal fade" id="modalMessages" tabindex="-1" aria-labelledby="modalMessages" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <p class="text-left">Estimado(a) Postulante:</p>
                
                <p class="text-left" [innerHTML]="messageList[currentIndex]"></p>

                <p class="text-left">
                    Atentamente, <br /> Dirección de Admisión, Santo Tomás.
                </p>
                <nav aria-label="Page navigation example" *ngIf="messageList.length > 1">
                    <ul class="pagination">
                        <li class="page-item" (click)="goToPrev()" *ngIf="currentIndex !== 0">
                            <span class="page-link" href="#" aria-label="Previous">
                                <span aria-hidden="true">&laquo;</span>
                            </span>
                        </li>
                        <li class="page-item" (click)="goToNext()" *ngIf="currentIndex < messageList.length -1">
                            <span class="page-link" href="#" aria-label="Next">
                                <span aria-hidden="true">&raquo;</span>
                            </span>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</div>
<!-- Modal Matrícula Activa -->